import styled from 'styled-components';

import SpinnerIcon from './spinner.svg?react';

export const StyledSpinnerIcon = styled(SpinnerIcon).attrs({
  'aria-label': 'spinner-icon',
  'data-testid': 'styled-spinner-icon',
})<{ variant: 'LIGHT' | 'DARK' }>`
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  max-width: 52px;
  max-height: 52px;

  path {
    width: 100%;
    height: 100%;
    fill: ${({ variant, theme }) =>
      variant === 'LIGHT' ? theme.border.color.dark : theme.background.color.menu};
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const SpinnerContainer = styled.div.attrs({
  'data-testid': 'spinner-container',
})<{ fullHeight?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${({ fullHeight }) => (fullHeight ? '100%' : 'auto')};
  width: 100%;
`;
